import { useState } from "react";
import { Link } from "react-router-dom";

import { DirIcon, TypeIcon, dateTime, time } from "@/components/cockpit/meta";

const FicheRow = ({ f }) => (
  <Link to={`/pipeline?lead=${f.fiche_id}`} className="ck-fiche" data-testid={`ck-fiche-${f.fiche_id}`}>
    <div className="ck-fiche-main">
      <strong>{f.title || `Fiche ${f.fiche_id}`}</strong>
      <span className="ck-muted">{[f.pipeline, f.step].filter(Boolean).join(" › ")}{f.owner_name ? ` · ${f.owner_name}` : ""}</span>
      {f.tags?.length > 0 && <span className="ck-tags">{f.tags.slice(0, 4).map((t) => <em key={t}>{t}</em>)}</span>}
    </div>
    <div className="ck-fiche-last">
      <span className="ck-types">{f.types.map((t) => <TypeIcon key={t} type={t} size={12} />)}</span>
      <span className="ck-muted"><DirIcon direction={f.last.direction} /> {f.last.summary}</span>
      <small>{dateTime(f.last.timestamp)} · {f.count} événement{f.count > 1 ? "s" : ""}</small>
    </div>
  </Link>
);

// Affichage par tranches de 60 : la page reste fluide même avec 500 fiches touchées
export const TouchedList = ({ fiches }) => {
  const [n, setN] = useState(60);
  return (
    <div className="ck-list" data-testid="ck-touched-list">
      {fiches.slice(0, n).map((f) => <FicheRow key={f.fiche_id} f={f} />)}
      {fiches.length > n && <button type="button" className="ck-more" onClick={() => setN(n + 120)} data-testid="ck-touched-more">Afficher {Math.min(120, fiches.length - n)} fiches de plus ({fiches.length - n} restantes)</button>}
    </div>
  );
};

export const Timeline = ({ items }) => {
  const groups = [];
  for (const i of items) {
    const d = new Date(i.timestamp);
    const label = `${d.toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "2-digit" })} · ${String(d.getHours()).padStart(2, "0")}h`;
    if (groups.at(-1)?.label !== label) groups.push({ label, items: [] });
    groups.at(-1).items.push(i);
  }
  return (
    <div className="ck-timeline" data-testid="ck-timeline">
      {groups.map((g) => (
        <section key={g.label}>
          <h4>{g.label}</h4>
          {g.items.map((i) => (
            <Link key={i.id} to={i.fiche_id ? `/pipeline?lead=${i.fiche_id}` : "#"} className="ck-event" data-testid={`ck-event-${i.id}`}>
              <TypeIcon type={i.type} />
              <span className="ck-event-time">{time(i.timestamp)}</span>
              <span className="ck-event-body"><strong>{i.fiche_title || `Fiche ${i.fiche_id}`}</strong><span><DirIcon direction={i.direction} /> {i.summary}</span></span>
              <span className="ck-muted ck-event-user">{i.user_name || "Système"}</span>
            </Link>
          ))}
        </section>
      ))}
    </div>
  );
};

export const ByUser = ({ fiches }) => {
  const blocks = {};
  for (const f of fiches) for (const u of f.users.length ? f.users : [f.owner_name || "Sans commercial"]) (blocks[u] ||= []).push(f);
  return (
    <div className="ck-users" data-testid="ck-by-user">
      {Object.entries(blocks).sort((a, b) => b[1].length - a[1].length).map(([u, list]) => (
        <section key={u} className="ck-user" data-testid={`ck-user-${u}`}>
          <header><strong>{u}</strong><span>{list.length} fiche{list.length > 1 ? "s" : ""}</span></header>
          {list.slice(0, 30).map((f) => (
            <Link key={f.fiche_id} to={`/pipeline?lead=${f.fiche_id}`} className="ck-user-fiche">
              <span className="ck-types">{f.types.map((t) => <TypeIcon key={t} type={t} size={11} />)}</span>
              <span>{f.title || `Fiche ${f.fiche_id}`}</span>
              <small className="ck-muted">{dateTime(f.last.timestamp)}</small>
            </Link>
          ))}
        </section>
      ))}
    </div>
  );
};
